<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Ban by IP
        <small>Here you can ban users</small>
      </h1>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-md-4">
          <!-- Default box -->
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Ban user</h3>
            </div>
            <div class="box-body">
              <div>
                <form class="form-horizontal">
                  <div class="form-group">
                    <label for="nickname" class="col-sm-2 control-label">Nick</label>
                    <div class="col-sm-10">
                      <input v-model="nickname" type="text" id="nickname" placeholder="Nickname" class="form-control">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="ip-address" class="col-sm-2 control-label">IP</label>
                    <div class="col-sm-10">
                      <input v-model.trim="ip" type="text" id="ip-address" placeholder="IP address" class="form-control">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="datetimepicker" class="col-sm-2 control-label">Date to</label>
                    <div class="col-sm-10">
                      <input type='text' class="form-control" id='datetimepicker' />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="type" class="col-sm-2 control-label">Ban type</label>
                    <div class="col-sm-10">
                      <select v-model="type" id="type" class="form-control">
                        <option value="1">Game - preusmerava na stranu ban</option>
                        <option value="2">Chat - gasi mu chat</option>
                        <option value="3">Skins - zabrana dodavanja</option>
                        <option value="4">Igra - ubija tab (oprezno)</option>
                        <option value="5">Salje mu poruku iz 'Reasona'</option>
                        <option value="6">Protrese mu ekran svakih 20 sek. Unban da ne trese stalno.</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="reason" class="col-sm-2 control-label">Reason</label>
                    <div class="col-sm-10">
                      <textarea v-model="reason" id="reason" class="form-control" rows="2"></textarea>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="box-footer">
              <div>
                <p class="text-danger text-right">{{ msg }}</p>
                <button @click="ban()" type="button" class="btn btn-info pull-right">
                  Ban
                </button>
              </div>
            </div> <!---->
          </div>

        </div>
        <div class="col-md-8">
          <table class="table table-condensed table-striped">
            <thead>
            <tr>
              <th>Nick</th>
              <th>Type</th>
              <!--<th>Server</th>-->
              <th>Reason</th>
              <th>Date</th>
              <th>Expire</th>
              <th>IP</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody v-if="bannedList.length > 0">

              <tr v-for="ban in bannedList" v-show="current_date < ban.date_to">
                <td>{{ decodeURI(ban.nickname) }}</td>
                <td>{{ calcType(ban.type) }}</td>
                <!--<td>{{ calcServers(ban.server) }}</td>-->
                <td>{{ ban.reason }}</td>
                <td>{{ ban.date_from }}</td>
                <td>{{ ban.date_to }}</td>
                <td>{{ ban.ip }}</td>
                <td><button @click="unban(ban.id)" class="btn btn-danger">Unban</button></td>
              </tr>

            </tbody>
            <tbody v-else>
            <div class="ui hidden divider"></div>
            <h3>
              List is empty
            </h3>
            <div class="ui hidden divider"></div>
            </tbody>
          </table>
          <div>
            <p>Ukoliko unbanujes nekog, posalji mu link: <a href="https://agar.rs/unba.html">http://agar.rs/unba.html</a></p>
          </div>
        </div>
      </div>

    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  export default {
    name: 'Ban',
    data: function () {
      return {
        bannedList: [],
        form: new Form({}),
        current_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
        nickname: '',
        ip: '',
        date_to: '',
        reason: '',
        type: 0,
        msg: ''
      }
    },
    mounted: function () {
      if (Number(this.$store.state.role) < 33) {
        this.$router.push('/dashboard')
      }
      var self = this
      $(function () {
        $('#datetimepicker').datetimepicker({
          locale: 'sr'
        })
        $(document).on('dp.change', '#datetimepicker', function (e) {
          self.date_to = e.date.utc().format()
        })
      })
      this.getBannedList()
    },
    methods: {
      getBannedList () {
        var self = this
        // var currentdate = new Date().toISOString().slice(0, 19).replace('T', ' ')

        this.form.post(baseUrl + 'Agar/getBannedList', {}).then(function (result) {
          if (result.status === 1) {
            self.bannedList = result.banned
          }
        }, function (reason) {
        })
      },
      unban: function (id) {
        var self = this
        let data = {
          id: id,
          token_header: localStorage.getItem('token_header'),
          token_log: localStorage.getItem('token_log')
        }
        this.form.post(baseUrl + 'Admin/unbanUser', data).then(function (result) {
          if (Number(result.status) === 1) {
            self.bannedList = []
            self.getBannedList()
          }
        }, function (reason) {
            // rejection
        })
      },
      ban: function () {
        if (this.date_to === '') {
          this.msg = 'Choose date'
          return 0
        }
        if (this.ip === '') {
          this.msg = 'Must enter IP address'
          return 0
        }
        if (this.type < 1 || this.type > 6) {
          this.msg = 'Choose type'
          return 0
        }
        var self = this
        let data = {
          nickname: encodeURI(this.nickname),
          ip: this.ip,
          reason: this.reason,
          date_to: this.date_to,
          type: this.type,
          token_header: localStorage.getItem('token_header'),
          token_log: localStorage.getItem('token_log'),
          by: this.$store.state.nickname
        }
        this.msg = ''
        this.form.post(baseUrl + 'Admin/banUser', data).then(function (result) {
          if (Number(result.status) === 1) {
            self.nickname = ''
            self.reason = ''
            self.date_to = ''
            self.type = 0
            self.ip = ''
           // $('#datetimepicker').data('DateTimePicker').clear()
            self.bannedList = []
            self.getBannedList()
          } else {
            self.msg = result.msg
          }
        }, function (reason) {
          // rejection
        })
      },

      calcType: function (type) {
        if (Number(type) === 1) return 'Igra'
        if (Number(type) === 2) return 'Chat'
        if (Number(type) === 3) return 'Skinovi'
        if (Number(type) === 4) return 'Kill'
        if (Number(type) === 5) return 'Poruka'
        if (Number(type) === 6) return 'Potres'
      },
      calcServers: function (servers) {
        if (servers === '') return 'Svi'
        return servers
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Index.vue?9c17f8d8